
import { Search, Bell, Filter, BarChart, Clock, Target, MonitorSmartphone, Calendar, Smartphone, Inbox, Mail, Database, User } from "lucide-react";
import { FeaturePageLayout } from "@/components/layout/FeaturePageLayout";
import { BenefitCard } from "@/components/ui/benefit-card";
import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";
import { useTranslation } from "react-i18next";
const Agent = () => {
  const {
    t
  } = useTranslation("platform");
  const agentBenefits = [{
    title: t("tenderAgent.realTimeMonitoring"),
    description: t("tenderAgent.realTimeMonitoringDescription"),
    icon: <Clock className="h-5 w-5 text-primary" />
  }, {
    title: t("tenderAgent.advancedFiltering"),
    description: t("tenderAgent.advancedFilteringDescription"),
    icon: <Filter className="h-5 w-5 text-primary" />
  }, {
    title: t("tenderAgent.smartMatching"),
    description: t("tenderAgent.smartMatchingDescription"),
    icon: <Search className="h-5 w-5 text-primary" />
  }, {
    title: t("tenderAgent.analytics"),
    description: t("tenderAgent.analyticsDescription"),
    icon: <BarChart className="h-5 w-5 text-primary" />
  }];
  const notificationBenefits = [{
    title: t("smartNotifications.neverMissDeadline"),
    description: t("smartNotifications.neverMissDeadlineDescription"),
    icon: <Clock className="h-5 w-5 text-primary" />
  }, {
    title: t("smartNotifications.personalizedAlerts"),
    description: t("smartNotifications.personalizedAlertsDescription"),
    icon: <Target className="h-5 w-5 text-primary" />
  }, {
    title: t("smartNotifications.multiChannelDelivery"),
    description: t("smartNotifications.multiChannelDeliveryDescription"),
    icon: <MonitorSmartphone className="h-5 w-5 text-primary" />
  }, {
    title: t("smartNotifications.calendarIntegrationBenefit"),
    description: t("smartNotifications.calendarIntegrationBenefitDescription"),
    icon: <Calendar className="h-5 w-5 text-primary" />
  }];
  const notificationTypes = [{
    title: t("smartNotifications.newTenderMatch"),
    description: t("smartNotifications.newTenderMatchDescription"),
    icon: <Inbox className="h-5 w-5 text-primary" />
  }, {
    title: t("smartNotifications.deadlineReminder"),
    description: t("smartNotifications.deadlineReminderDescription"),
    icon: <Clock className="h-5 w-5 text-primary" />
  }, {
    title: t("smartNotifications.documentUpdate"),
    description: t("smartNotifications.documentUpdateDescription"),
    icon: <Mail className="h-5 w-5 text-primary" />
  }, {
    title: t("smartNotifications.questionAnswer"),
    description: t("smartNotifications.questionAnswerDescription"),
    icon: <Smartphone className="h-5 w-5 text-primary" />
  }];
  return <FeaturePageLayout title={t("agent.combinedTitle")} subtitle={t("tenderAgent.subtitle")} description={t("agent.combinedDescription")} icon={<Search className="h-8 w-8 text-white" />} bgColor="bg-gradient-to-r from-primary/90 via-purple-600/90 to-primary/90">
      {/* Combined Agent Content */}
      <section className="mb-20">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">{t("tenderAgent.howWorks")}</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {t("tenderAgent.howWorksDescription")}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.5
        }} viewport={{
          once: true
        }} className="bg-gray-50 p-8 rounded-lg">
            <h3 className="text-xl font-semibold mb-4 flex items-center">
              <Database className="h-5 w-5 mr-2 text-primary" />
              Adgang til Offertios udbudsportal
            </h3>
            <p className="text-gray-600 mb-4">
              {t("tenderAgent.tenderMatchingDescription")}
            </p>
            <ul className="space-y-2 text-gray-600">
              
              
              
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} viewport={{
          once: true
        }} className="bg-gray-50 p-8 rounded-lg">
            <h3 className="text-xl font-semibold mb-4 flex items-center">
              <User className="h-5 w-5 mr-2 text-primary" />
              Personlige profiler
            </h3>
            <p className="text-gray-600 mb-4">
              Opsæt din virksomhedsprofil med søgepræferencer. Filtrer f.eks. efter branchekoder, ydelser eller geografi. De avancerede søgefiltre som indstilles til din virksomhedsprofil, gør at du kun modtager relevante udbud for din virksomhed.
            </p>
            <ul className="space-y-2 text-gray-600">
              
              
              
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} viewport={{
          once: true
        }} className="bg-gray-50 p-8 rounded-lg">
            <h3 className="text-xl font-semibold mb-4 flex items-center">
              <Mail className="h-5 w-5 mr-2 text-primary" />
              Notifikationer direkte på din mail
            </h3>
            <p className="text-gray-600 mb-4">
              {t("tenderAgent.smartFilteringDescription")}
            </p>
            <ul className="space-y-2 text-gray-600">
              
              
              
            </ul>
          </motion.div>
        </div>
      </section>
      
      {/* Agent Benefits Section */}
      

      {/* Notification System Section - From the Notifications tab */}
      

      {/* Notification Types Section */}
      

      {/* Notification Benefits Section */}
      
    </FeaturePageLayout>;
};
export default Agent;
